export function dispatchCustomEvent(eventKey: string, data: any = []) {
    const event = new CustomEvent(eventKey, {
        detail: { eventKey: eventKey, data: data },
        bubbles: true,
        cancelable: true,
    });
    window.dispatchEvent(event)
}

export function listener(id: string, handleFunction: EventListenerOrEventListenerObject, ref: any = null) {
    if (ref && ref.current) {
        ref.current.addEventListener(id, handleFunction)
        return () => {
            ref.current.removeEventListener(id, handleFunction)
        }
    } else {
        window.addEventListener(id, handleFunction)
        return () => {
            window.removeEventListener(id, handleFunction)
        }
    }
}
